import { useEffect } from 'react';
import { Text } from '@chakra-ui/react';
import { useContacts, usePaginateContacts } from 'hooks/contacts';

import AsyncTable from 'components/Tables/AsyncTable';
import { useFilters } from 'hooks/filters';
import { phoneFormat } from 'functions/maskFormats';

const columns = [
	{
		Header: 'Nome',
		accessor: 'name'
	},
	{
		Header: 'Matrícula',
		accessor: 'appai_id'
	},
	{
		Header: 'Telefone',
		accessor: 'phone',
		Cell: ({ value }) => <Text>{phoneFormat(value)}</Text>
	}
];

const ContactsTable = () => {
	const { filters } = useFilters();
	const { rows, page, perPage, total, setToDelete, setDeleteModalOpen } =
		useContacts();
	const [paginateContacts, { loading }] = usePaginateContacts();

	const deleteContact = (id) => {
		setToDelete(id);
		setDeleteModalOpen(true);
	};

	const fetchData = ({ pageSize, pageIndex, search }) => {
		if (pageSize != perPage) pageIndex = 1;
		paginateContacts({
			variables: {
				first: pageSize || perPage,
				page: pageIndex || page,
				search: search || '',
				...filters
			}
		});
	};

	useEffect(() => {
		if (filters && Object.keys(filters).length > 0) {
			paginateContacts({
				variables: {
					first: perPage,
					page,
					...filters
				}
			});
		}
	}, [filters]);

	return (
		<AsyncTable
			fetchData={fetchData}
			isLoaded={!loading}
			data={!loading ? rows : [{}, {}, {}, {}]}
			columns={columns}
			total={total}
			size={perPage}
			asyncPage={page}
			searchByName
			baseRoute="contatos"
			removeAction={deleteContact}
			linkRow
		/>
	);
};

export default ContactsTable;
